import { useAppDispatch, useAppSelector } from "@/store"
import {
  selectResolutionList,
  setResolutionItem,
  selectResolutionItem,
  selectAgentResolutionItem,
  setIsUseCommonShortcut,
  selectIsUseMacCommonShortcut,
  selectMouseScrollSpeed,
  setMouseScrollSpeed,
  setIsGameModel,
  selectIsGameModel,
} from "@/stores/remote_desk_state_slice"
// import { VideoStatsUseCase } from "@/usecases/video_statistic"
import { OS, getOS } from "@/utils/os"
import {
  Box,
  Button,
  Flex,
  Slider,
  SliderFilledTrack,
  SliderThumb,
  SliderTrack,
  Switch,
  Text,
  Tooltip,
} from "@chakra-ui/react"
import React, { CSSProperties, useEffect, useState } from "react"
import { AppSelect, AppSelectOption } from "@/widgets/Common"
import { DisplayUseCase } from "@/usecases/display"

import { selectConnStats } from "@/stores/conn_stats_slice"
import { parseResolution } from "@/utils/tools"
import { Resolution } from "@/sdk"
// import { isDevEnv } from "@/config/env"
import AudioContent from "./audio_content"
import VideoContent from "./video_content"
import ScaleRatioContent from "./scale_ratio_content"
import { QuestionOutlineIcon } from "@chakra-ui/icons"
import { WallpaperSetting } from "./wallpaper_setting"
import { ConnectionUseCase } from "@/usecases/connection"
import { isAssistLogin } from "@/pages/login/login_hook"

interface SettingsContentProps {
  onModalOpenChange?: (isOpen: boolean) => void
}

export const SettingsContent: React.FC<SettingsContentProps> = ({
  onModalOpenChange,
}) => {
  return (
    <Flex padding="10px 10px" direction={"column"} height="100%">
      <MacSetting onModalOpenChange={onModalOpenChange} />
    </Flex>
  )
}

const MacSetting: React.FC<SettingsContentProps> = ({ onModalOpenChange }) => {
  const [isOpenWallpaperModal, setIsOpenWallpaperModal] = useState(false)
  const selectTriggerStyle: CSSProperties = {
    background: "transparent",
    boxShadow: "none",
    minHeight: "28px",
  }
  const headerStyle: CSSProperties = {
    color: "#FFFFFF",
    fontSize: "13px",
  }
  const itemStyle: CSSProperties = {
    border: "1px solid #ffffffd9",
    borderRadius: "10px",
    padding: "4px 10px",
    marginBottom: "8px",
  }
  const selectItemStyle: CSSProperties = {
    border: "1px solid #ffffffd9",
    borderRadius: "10px",
    padding: "4px 2px 4px 10px",
    marginBottom: "8px",
  }
  const dispatch = useAppDispatch()
  const isMac = getOS() === OS.MacOS
  const [isGameCloudComputer, setIsGameCloudComputerState] = useState(
    ConnectionUseCase.isGameCloudComputer()
  )
  // 分辨率列表
  const resolutionList = useAppSelector(selectResolutionList)

  // 内存中的分辨率
  const resolutionItem = useAppSelector(selectResolutionItem)
  const agentResolutionItem = useAppSelector(selectAgentResolutionItem)
  // 连接状态中的分辨率
  const connStats = useAppSelector(selectConnStats)
  const connStatsItem = parseResolution(connStats.resolution)

  const connStatsResolution = {
    label: connStats.resolution, // "1920 x 1080"
    value: connStatsItem, // { width: 1920, height: 1080 }
  }

  const { width, height } = resolutionItem
  const resolutionListItem = resolutionList.find((o) => {
    return (
      o.value.width === resolutionItem.width &&
      o.value.height === resolutionItem.height
    )
  })
  const defaultSelectedOption =
    width > 0 && height > 0 && resolutionListItem
      ? resolutionListItem
      : connStatsResolution

  // console.log(
  //   "deviceInfo connStatsResolution: ",
  //   connStatsResolution,
  //   "resolutionListItem: ",
  //   resolutionListItem,
  //   "agentResolutionItem: ",
  //   agentResolutionItem
  // )

  const selectedOption: AppSelectOption = isAssistLogin
    ? (agentResolutionItem ?? defaultSelectedOption)
    : defaultSelectedOption

  // console.log("deviceInfo selectedOption: ", selectedOption)

  // 启用Mac快捷键
  const isUseMacCommonShortcut = useAppSelector(selectIsUseMacCommonShortcut)
  // 游戏模式
  const isGameModel = useAppSelector(selectIsGameModel)
  const mouseScrollSpeed = useAppSelector(selectMouseScrollSpeed)
  const [mouseScrollSpeedDraft, setMouseScrollSpeedDraft] =
    useState(mouseScrollSpeed)

  useEffect(() => {
    onModalOpenChange?.(isOpenWallpaperModal)
  }, [isOpenWallpaperModal, onModalOpenChange])

  useEffect(() => {
    return () => onModalOpenChange?.(false)
  }, [onModalOpenChange])

  useEffect(() => {
    setIsGameCloudComputerState(ConnectionUseCase.isGameCloudComputer())
    const unsubscribe = ConnectionUseCase.setGameCloudComputerListener(
      setIsGameCloudComputerState
    )
    return () => {
      unsubscribe?.()
    }
  }, [])

  useEffect(() => {
    setMouseScrollSpeedDraft(mouseScrollSpeed)
  }, [mouseScrollSpeed])

  const handleCommonShortcutChange = (value: boolean) => {
    dispatch(setIsUseCommonShortcut(value))
  }

  const handleGameModeChange = (value: boolean) => {
    dispatch(setIsGameModel(value))
  }

  // 更改分辨率
  const handleResolutionChange = (option: AppSelectOption) => {
    dispatch(setResolutionItem(option.value as Resolution))

    DisplayUseCase.setRemoteStreamResolution(
      option.value.width as number,
      option.value.height as number
    )
  }
  return (
    <Flex
      direction={"column"}
      width={"100%"}
      height="100%"
      id="full-screen-unvideo-element-tag"
      gap="6px"
    >
      <Box style={selectItemStyle}>
        {!isAssistLogin ? (
          <Flex
            direction={"row"}
            alignItems="center"
            justifyContent="space-between"
            minHeight="34px"
          >
            <Text style={headerStyle}>分辨率</Text>
            <Box width="185px" flexShrink={0}>
              <AppSelect
                value={selectedOption}
                options={resolutionList}
                triggerStyle={selectTriggerStyle}
                onChange={(selected) => {
                  handleResolutionChange(selected)
                }}
              />
            </Box>
          </Flex>
        ) : (
          <></>
        )}
        <ScaleRatioContent
          resolution={connStatsItem ?? { width: 0, height: 0 }}
          triggerStyle={selectTriggerStyle}
        />
      </Box>

      {/* <AudioContent itemStyle={itemStyle} /> */}
      {isGameCloudComputer ? (
        <Flex
          direction={"row"}
          justifyContent={"space-between"}
          alignItems="center"
          style={itemStyle}
          minHeight="34px"
        >
          <Text style={headerStyle}>游戏模式</Text>
          <Switch
            isChecked={isGameModel}
            onChange={(event) => handleGameModeChange(event.target.checked)}
          />
        </Flex>
      ) : (
        <></>
      )}

      <Box style={selectItemStyle}>
        <AudioContent />
        <VideoContent triggerStyle={selectTriggerStyle} />
      </Box>

      <Flex
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        style={itemStyle}
        minHeight="34px"
      >
        <Text style={headerStyle} whiteSpace="nowrap" flexShrink={0}>
          滚轮速度
        </Text>
        <Box
          width="185px"
          paddingX="8px"
          flexShrink={0}
          position="relative"
          onMouseDown={(event) => event.stopPropagation()}
          onPointerDown={(event) => event.stopPropagation()}
          onClick={(event) => event.stopPropagation()}
        >
          <Slider
            aria-label="滚轮速度"
            min={0}
            max={1}
            step={0.01}
            value={mouseScrollSpeedDraft}
            focusThumbOnChange={false}
            onChange={setMouseScrollSpeedDraft}
            onChangeEnd={(value) => dispatch(setMouseScrollSpeed(value))}
            onMouseDown={(event) => event.stopPropagation()}
            onPointerDown={(event) => event.stopPropagation()}
          >
            <SliderTrack height="4px" background="#ffffff20">
              <SliderFilledTrack background="#ffffffd9" />
            </SliderTrack>
            <SliderThumb boxSize="10px" background="white" />
          </Slider>
        </Box>
      </Flex>

      {/* 壁纸 */}
      <Flex
        direction={"row"}
        justifyContent={"space-between"}
        alignItems="center"
        style={itemStyle}
        minHeight="34px"
      >
        <Text style={headerStyle}>壁纸</Text>
        <Button
          size="xs"
          background="#5998f2e3"
          color="white"
          fontSize="12px"
          _hover={{ background: "#438bf2e3" }}
          onClick={() => setIsOpenWallpaperModal(true)}
        >
          设置
        </Button>
      </Flex>
      <WallpaperSetting
        isOpen={isOpenWallpaperModal}
        onClose={() => setIsOpenWallpaperModal(false)}
      />

      {isMac ? (
        <Box style={{ ...itemStyle, padding: "1px 10px" }}>
          <Flex
            direction={"row"}
            justifyContent={"space-between"}
            alignItems="center"
            minHeight="28px"
          >
            <Text style={headerStyle}>
              启用Mac快捷键 &nbsp;&nbsp;
              <Tooltip
                hasArrow
                label={
                  "目前支持映射快捷键有：'command+C'、'command+X'、'command+V'、'command+Z'、'command+A'、'command+S'、'command+O'、'command+N'、'command+P'、'command+F'、'command+H'、'command+W'、'command+Tab'"
                }
                bg="gray.500"
                color="white.600"
                fontSize="12px"
                placement="bottom"
                width="235px"
              >
                <QuestionOutlineIcon />
              </Tooltip>
            </Text>

            <Switch
              isChecked={isUseMacCommonShortcut}
              onChange={(event) =>
                handleCommonShortcutChange(event.target.checked)
              }
            />
          </Flex>
        </Box>
      ) : (
        <></>
      )}

      {/* 将 WebRTC 统计信息写入本地 csv 文件 */}
      {/* {isDevEnv() ? (
        <Button
          onClick={() => VideoStatsUseCase.writeStatsInfoToCSVFile()}
          marginTop="20px"
          size="sm"
        >
          统计CSV文件
        </Button>
      ) : (
        <></>
      )} */}
    </Flex>
  )
}
